import UploadDialog from './UploadDialog';

import './index.css';

export default UploadDialog;
